


//#########
const propertyForO = [ '','RENT', 'PG ACCOMMODATION'];
export const propertyFor = () => {
  return propertyForO.map(value => ({ key: value, text: value, value: value ,style:{fontSize:'18px'} }));
};

//############
const carParkingCoveredO = ['1', '2', '3', '4', '5', '6', '6+'];
export const carParkingCovered = () => {
  return carParkingCoveredO.map(value => ({
    key: value,
    text: value,
    value: value,style:{fontSize:'18px'}
  }));
};
//###############
const carParkingOpenO = ['1', '2', '3', '4', '5', '6', '6+'];
export const carParkingOpen = () => {
  return carParkingOpenO.map(value => ({
    key: value,
    text: value,
    value: value,style:{fontSize:'18px'}
  }));
};

//###################
const entryO = [

  'East',
  'West',
  'North',
  'South',
  'North - East',
  'North - West',
  'South - East',
  'South -West'
];
export const entry = () => {
  return entryO.map(value => ({
    key: value,
    text: value,
    value: value,style:{fontSize:'18px'}
  }));
};
//#######
